import request from '@/utils/request'

/**
 * 获取销售成本列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回请求结果的Promise
 */
export function getSellingCostList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mallReport/sellingCost',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}